export { default } from './DialogHeader';
